const PurchaseView = Object.freeze({
  default: 'default',
  token: 'token',
  paylink: 'paylink',
});

export default PurchaseView;
